<template>
    <div>
        <section>
            <div class="container">
                <!-- title and ADD column -->
                <div class="columns is-mobile">
                    <div class="column">
                        <p class="title has-text-left">Experimental Datasets</p> 
                    </div>
                </div>

                <div class="tile is-ancestor">
                    <div class="tile has-text-left is-12 is-vertical is-parent">
                        <div class="tile is-child box">
                            <div class="columns is-mobile">
                                <div class="column is-one-quarter"><strong>Experimental Plan:</strong></div>
                                <div class="column">{{currentExperimentalPlan.name}}</div> 
                                <div class="column">
                                    <a class="button is-small is-primary" v-on:click="openExperimentalPlan()">
                                        <span>Open Experimental Plan</span>
                                    </a>
                                </div>                        
                            </div>
                        </div>
                    </div>
                </div>
                
                
                <!-- First Column -->
                <div class="columns is-mobile is-centered">          
                    <div class="column">                 
                        <section>
                            <b-collapse class="panel" :open.sync="isOpenActive">
                                <div slot="trigger" class="panel-heading">
                                    <p class="has-text-left">Active Experimental Datasets</p>
                                </div>

                                <div class="panel-block">
                                    <div class="container">
                                        <!-- Table start -->
                                        <b-table
                                            :data="isEmpty ? [] : activeExperimentalDatasets"
                                            :striped=true
                                            :hoverable=true
                                            :loading="isLoading"
                                            :mobile-cards=true>

                                            <template slot-scope="props"> 
                                                <b-table-column field="name" label="Name">
                                                    <a v-on:click="viewExperimentalDataset(props.row)">{{ props.row.name }}</a>
                                                </b-table-column>

                                                <b-table-column field="staus" label="Status">
                                                    <a v-on:click="viewExperimentalDataset(props.row)">{{ props.row.status }}</a>
                                                </b-table-column>

                                                <b-table-column field="created_at" label="Date of creation" centered>
                                                    <a v-on:click="viewExperimentalDataset(props.row)">{{ new Date(props.row.created_at).toLocaleDateString() }}</a>
                                                </b-table-column>

                                                <b-table-column field="last_accessed" label="Last accessed" centered>
                                                    <a v-on:click="viewExperimentalDataset(props.row)"><span> 
                                                        {{ new Date(props.row.last_accessed).toLocaleDateString() }}
                                                    </span></a>
                                                </b-table-column>

                                                <b-table-column field="last_accessed" label="Action" centered>
                                                    <span class=""> 
                                                        <!-- <div class="column">
                                                            <a v-on:click="viewExperimentalDataset(props.row)" class="button is-small is-primary ">View</a> 
                                                        </div>  -->
                                                        <span class="">
                                                            <a  v-if="props.row.status != 'LOCKED'" v-on:click="uploadExperimentalDataset(props.row)" class="button is-small is-info">Upload</a> 
                                                            <a style="margin-right:20px"></a>
                                                            <a v-on:click="duplicateExperimentalDataset(props.row)" class="button is-small is-link">Duplicate</a> 
                                                        </span>
                                                    </span>  
                                                </b-table-column>
                                            </template>

                                            <template slot="empty">
                                                <div v-if="activeExperimentalDatasets" class="has-text-centered column">
                                                    <p>No Active Experimental Dataset...</p>
                                                    <p>Add a new one</p>
                                                    <router-link class="is-rounded button is-small is-primary" to="/new-experimental-dataset">
                                                        <b-icon
                                                            pack="fas"
                                                            icon="plus"
                                                            size="is-small">
                                                        </b-icon>
                                                    </router-link>
                                                </div>

                                                <b-table
                                                    :loading="true"
                                                    :focusable="true"
                                                    :mobile-cards="true"
                                                    v-else>

                                                    <template slot-scope="props"> 
                                                    </template>
                                                </b-table>
                                            </template>
                                        </b-table>
                                        <!-- Table end -->
                                    </div>
                                </div>
                            </b-collapse>
                        </section>
                    </div>
                </div>

                <!-- Second Column -->
                <div class="columns is-mobile is-centered">
                    <div class="column">                 
                        <section>
                            <b-collapse class="panel" :open.sync="isOpenArchived">
                                <div slot="trigger" class="panel-heading">
                                    <p class="has-text-left">Archived ExperimentalDatasets</p>
                                </div>

                                <div class="panel-block">
                                    <div class="container">
                                        <!-- Table start -->
                                        <b-table
                                            :data="isEmpty ? [] : archivedExperimentalDatasets"
                                            :striped=true
                                            :hoverable=true
                                            :loading="isLoading"
                                            :mobile-cards=true>

                                            <template slot-scope="props"> 
                                                <b-table-column field="name" label="Name">
                                                    {{ props.row.name }}
                                                </b-table-column>

                                                <b-table-column field="staus" label="Status">
                                                    {{ props.row.status }}
                                                </b-table-column>

                                                <b-table-column field="created_at" label="Date of creation" centered>
                                                    {{ new Date(props.row.created_at).toLocaleDateString() }}
                                                </b-table-column>

                                                <b-table-column field="last_accessed" label="Last accessed" centered>
                                                    <span> 
                                                        {{ new Date(props.row.last_accessed).toLocaleDateString() }}
                                                    </span>
                                                </b-table-column>
                                            </template>

                                            <template slot="empty">
                                                <div class="has-text-centered column" v-if="archivedExperimentalDatasets">
                                                    <p>No Archived Experimental Datasets...</p>
                                                </div>

                                                <div v-else>
                                                    <b-table
                                                        :loading="true"
                                                        :focusable="true"
                                                        :mobile-cards="true">

                                                        <template slot-scope="props"> 
                                                        </template>
                                                    </b-table>
                                                </div>
                                                
                                            </template>
                                        </b-table>
                                        <!-- Table end -->
                                    </div>
                                </div>
                            </b-collapse>
                        </section>
                    </div>
                </div>
            </div>
        </section>

        <router-link to="/new-experimental-dataset">
            <fab
            :position="position"
            :bg-color="bgColor"
            :enable-rotation="false"
            :main-tooltip=addtooltip
            ></fab>
        </router-link>

    </div>    
</template>

<script>
import fab from 'vue-fab'
export default {
    name: "ExperimentalDatasetsComponent",
    components: {
        fab
    },
    props: ["activeExperimentalDatasets", "archivedExperimentalDatasets", "currentExperimentalPlan"],
    data() {

        return {            
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false,
            // floating button start
            bgColor: '#00CD66', //#7957d5
            position: 'bottom-right',
            addtooltip: "Add A New Experimental Dataset"
            // floating button end
        }
    },
    methods:{
        cache(){
            // console.log('Cache Cleared');
        },
        alert(){
            alert('Clicked on alert icon');
        },
        viewExperimentalDataset: function (currentExperimentalDataset) {
            // console.log("view btn clicked for: ", currentExperimentalDataset.name)
            this.$emit("viewExperimentalDataset", currentExperimentalDataset);
        },
        uploadExperimentalDataset: function (currentExperimentalDataset) {
            // console.log("upload btn clicked for: ", currentExperimentalDataset.name)
            this.$emit("uploadExperimentalDataset", currentExperimentalDataset);
        },
        duplicateExperimentalDataset: function(currentExperimentalDataset){
            this.$emit("duplicateExperimentalDataset", currentExperimentalDataset);
        },
        openExperimentalPlan: function(){
            this.$emit("openExperimentalPlan", this.currentExperimentalPlan)
        }
    }
}
</script>

